module SeniorHelp.Opportunities
{
    let url: string;
    let modalBody: HTMLDivElement;
    let forms: OpportunityForm[] = [];

    class OpportunityForm
    {
        private trigger: HTMLButtonElement;
        private postcodeInput: HTMLInputElement;

        constructor(container: HTMLFormElement)
        {
            this.trigger = container.querySelector("button") as HTMLButtonElement;
            this.trigger.addEventListener("click", (ev) => this.checkAvailability(ev));

            this.postcodeInput = container.querySelector("[name='Postcode']") as HTMLInputElement;
        }

        private checkAvailability(ev: Event)
        {
            ev.preventDefault();
            modalBody.innerHTML = "";
            if (this.postcodeInput.value === "")
            {
                return;
            }
            DBS.PartialHost.UpdateView(url.replace("--postcode--", this.postcodeInput.value), modalBody);
            $("#opportunities-checker-modal").modal("show");
        }
    }

    export function Initialise(checkUrl: string)
    {
        url = checkUrl;
        modalBody = document.querySelector("#opportunities-checker-modal .form-block") as HTMLDivElement;

        const formElems = document.getElementsByClassName("availability-form");
        for (var i = 0; i < formElems.length; i++)
        {
            const form = new OpportunityForm(formElems[i] as HTMLFormElement);
            forms.push(form);
        }
    }
}